module.exports = __webpack_public_path__ + "media/application/images/icons/recommended-7baaa6b29f495bdffa06988460a713a4.svg";